import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createBlog, updateBlog, fetchBlogById } from '../../redux/features/blogsSlice';
import { AlertCircle } from 'lucide-react';
import BlogForm from './../../Components/Admin/BlogForm';


const BlogEditPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const blog = useSelector(state => state.blogs.items.find(b => b.id === id));

    useEffect(() => {
        if (id && !blog) {
            dispatch(fetchBlogById(id));
        }
    }, [id, blog, dispatch]);

    const handleSubmit = async (formData) => {
        setLoading(true);
        setError(null);
        try {
            if (id) {
                await dispatch(updateBlog({ blogId: id, updates: formData })).unwrap();
            } else {
                await dispatch(createBlog(formData)).unwrap();
            }
            navigate('/admin/blogs');
        } catch (err) {
            setError(err.message || 'An error occurred while saving the blog.');
        } finally {
            setLoading(false);
        }
    };

    if (id && !blog && !error) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-50">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
            </div>
        );
    }

    return (
        <div className="min-h-screen">
            {error && (
                <div className="max-w-5xl mx-auto px-4 py-4">
                    <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg">
                        <div className="flex items-center">
                            <AlertCircle className="w-5 h-5 text-red-400 mr-2" />
                            <p className="text-sm text-red-700">{error}</p>
                        </div>
                    </div>
                </div>
            )}

            <BlogForm 
                initialData={blog} 
                onSubmit={handleSubmit} 
            />

            {loading && (
                <div className="fixed inset-0 bg-gray-500 bg-opacity-25 flex items-center justify-center">
                    <div className="bg-white p-4 rounded-lg shadow-lg">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mx-auto"></div>
                        <p className="mt-2 text-sm text-gray-600">Saving changes...</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BlogEditPage;